<div class="display">
  <div class="col-md-11 align">
  <img id="langlogo" *ngIf="LogoNL" src="../../../../assets/Logos/logo-NL.svg" class="logo" alt="Federale logo">
  <img id="langlogo" *ngIf="LogoFR" src="../../../../assets/Logos/logo-FR.svg" class="logo" alt="Federale logo">
    <p class="header-text col-md-9">
      {{'LOGIN_OD0001' | translate}}
    <!-- Bienvenue sur l'outil de declaration de Federale Assurance  -->
  </p>
    <!-- <p class="header-text col-md-9">{{welcome}} </p> -->
  </div> 
    <div class="language-change col-md-1" id="languageDropdown" (click)="changeLanguage()">
      {{ defaultLanguage === 'NL'? 'FR': 'NL' }}
    </div>

    <!-- <div class="form-group">
      <select class="form-control font-18" id="languageDropdown" #selectedLang
          (change)="switchLang(selectedLang.value)">
          <option *ngFor="let language of translate.getLangs()" [value]="language"
              [selected]="language === defaultLanguage">
              {{ language }}
          </option>
      </select>
  </div> -->
    
</div>
